// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueResource from 'vue-resource';
import VueLazyload from 'vue-lazyload';
import BoostrapVue from 'bootstrap-vue';
import VueProgressBar from 'vue-progressbar';
import VueResourceProgressBarInterceptor from 'vue-resource-progressbar-interceptor';

// import fundebug from "fundebug-javascript";
import Tms from '@/plugin/tms';
import store from '@/store';

import App from './App';
import router from '../src/router/pc_index';
import '@/config';

import '@/views/picture/assets/styles/index.css';

import '@/js/common/api';
import '@/js/common/nodeapi';
import '@/js/common/login';
import '@/js/common/storage';

import * as filter from '@/js/filters';
Object.keys(filter).forEach((key) => {
  Vue.filter(key, filter[key]);
});

import {VueMasonryPlugin} from 'vue-masonry';
Vue.use(VueMasonryPlugin);

// 颜色选择器插件
import colorPicker from '@/plugin/vue-color-picker';

Vue.use(colorPicker);

Vue.use(VueResource);
Vue.use(BoostrapVue);
Vue.use(VueLazyload);
Vue.use(VueProgressBar);
// Vue.use(VueResourceProgressBarInterceptor);
// 设置进度条，超过50ms未响应的API将显示进度条
Vue.use(VueResourceProgressBarInterceptor, {
  latencyThreshold: 50,
  responseLatency: 50,
});

// 引入tms组件
Vue.use(Tms);

Vue.config.productionTip = false;

import InfiniteScroll from '../src/components/InfiniteScroll';

Vue.component('InfiniteScroll', InfiniteScroll);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App,
  },
});